import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import RoomAmenityTranslationGenerated from './RoomAmenityTranslation.generated';
import RoomAmenityTranslation from '../RoomAmenityTranslation';


export class RoomAmenityGeneratedEntityManager<BT extends RoomAmenityTranslationGenerated, B extends RoomAmenityGenerated<BT>> extends EntityWithTranslationManager<BT, B>
{
	translationEntityClass: any = RoomAmenityTranslation;

    constructor(parameters: EntityWithTranslationManagerParameters<BT, B>)
    {
        super({
            name: parameters.name ?? 'RoomAmenity',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'icon', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'orderNo', type: BusinessEntityFieldType.Integer, isInput: false },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'roomAmenities',
            translationsCustomGraphQlFields: 'name',
        });
    }

}
export class RoomAmenityGenerated<BT extends RoomAmenityTranslationGenerated> extends BusinessEntityWithTranslation<BT>
{
	/** An identifier for an icon (e.g., font-awesome class or relative file path like custom-icons/wifi.webp) */
	icon!: string;
	/** The order number of the entity. This is automatically set by the system. The value is updated automatically when the entity is moved up or down in the list. */
	orderNo: number = 0;
	/** The name of the foreign key to the translated entity. */
	translationForeignKeyName: string = 'roomAmenity';
	/** The primary language of the entity. */
	primaryLanguage: string = 'ro';

}

export default RoomAmenityGenerated;